import call from '~/assets/icons/call.svg';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	StyledBg,
	StyledButton,
	StyledButtonsContainer,
	StyledContainer,
} from './AppPhoneIncomingCall.styled';

const AppPhoneIncomingCall = () => {
	const phoneState = useObservable(rage.phoneCalls.getCallState());

	return (
		<StyledContainer>
			<StyledBg />
			<Text style={{ fontSize: 14, opacity: 0.25, marginTop: 84 }}>
				Вам звонит
			</Text>
			<Text style={{ fontSize: 30, marginTop: 20 }}>
				{phoneState?.contactName}
			</Text>
			<Text style={{ fontSize: 18, marginTop: 20 }}>
				{phoneState?.contactNumber}
			</Text>
			<StyledButtonsContainer>
				<StyledButton
					style={{ backgroundColor: '#A82F31' }}
					onClick={() => rage.phoneCalls.rejectCall()}
				>
					<img src={call} style={{ transform: 'rotate(135deg)' }} />
				</StyledButton>
				<StyledButton
					style={{ backgroundColor: '#00821C' }}
					onClick={() => rage.phoneCalls.answerCall()}
				>
					<img src={call} style={{ rotate: '-90deg' }} />
				</StyledButton>
			</StyledButtonsContainer>
		</StyledContainer>
	);
};

export { AppPhoneIncomingCall };
